import { render, staticRenderFns } from "./DetachIcon.vue?vue&type=template&id=ea32cdb6"
import script from "./DetachIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./DetachIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports